<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="4" class="mr-5">
        <base-material-stats-card
          color="billit"
          icon="mdi-home-city-outline"
          title="Company Size"
          :value="`You have ${$store.state.locations.length} ${$store.getters.locU}${$store.state.locations.length === 1 ? '' : 's'}`"
          :sub-text="` Under ${$store.state.user.displayName}`"
        />
      </v-col>
      <v-col cols="4">
        <base-material-stats-card
          color="billit"
          icon="mdi-map-outline"
          title="Company Reach"
          :value="`Across ${$store.getters.stateCount.length} State${$store.getters.stateCount.length === 1 ? '' : 's'}`"
          :sub-text="` Under ${$store.state.user.displayName}`"
        />
      </v-col>
      <!-- <v-col cols="4">
        <base-material-stats-card
          color="billit"
          icon="mdi-view-dashboard-outline"
          title="Tip"
          value="Organize Carriers"
          sub-text="Use locations to organize carriers"
        />
      </v-col>
      <v-col cols="4">
        <base-material-stats-card
          color="billit"
          icon="mdi-lock-outline"
          title="Tip"
          value="Access Level"
          sub-text="Locations can be used to manage permission-based roles"
        />
      </v-col> -->
      <v-col cols="12">
        <v-layout row justify-end class="pr-2 mt-2 mb-1">
          <!-- <v-spacer></v-spacer> -->
          <v-btn to="/build" v-if="$route.hash !== '#tutorial'" color="billit" class="font-weight-bold" height="35">Access Build</v-btn>
          <AddLocation/>
        </v-layout>
      </v-col>
      <v-col cols="12">
        <v-expansion-panels accordion hover style="border-radius: 6px;">
          <v-expansion-panel v-for="(location, n) in editLocations" :key="n">
            <v-expansion-panel-header class="py-5 font-weight-light" style="font-size: 18px;">
              <!-- {{ n === 0 ? 'mdi-home-circle-outline' : 'mdi-map-marker-outline' }} -->
              <v-icon class="mr-2" size="32" style="max-width: 50px;" v-text="$store.getters.locL === 'client' ? 'mdi-briefcase-account-outline' : 'mdi-map-marker-outline'"></v-icon>
              <!-- <span>Location #{{ n }} </span> -->
              <span>{{ location.name }}</span>
            </v-expansion-panel-header>

            <v-expansion-panel-content class="font-weight-light mt-2 px-5 display-1">
              <v-layout align-center class="mt-3 mb-8 pl-3 pr-8" row wrap>
                <v-flex md3>
                  <v-text-field
                    v-model="location.name" hide-details
                    label="Name" @input="showSave = true" dense
                  ></v-text-field>
                </v-flex>
                <v-spacer></v-spacer>
                <span class="font-italic body-2 grey--text">Added on {{ getTime(location.created.toDate()) }}</span>
              </v-layout>
              <v-layout align-center class="pb-5">
                <v-flex md4>
                  <v-select
                    :items="$store.state.stateSelect"
                    v-model="location.state"
                    label="State" @input="showSave = true"
                    filled shaped dense hide-details
                  ></v-select>
                </v-flex>
                <v-flex class="mx-4" md4>
                  <v-select
                    :items="$store.getters.citySelect(location.state)"
                    v-model="location.city" hide-details
                    label="City" @input="showSave = true"
                    filled shaped dense
                  ></v-select>
                </v-flex>
                <!-- <v-flex md3>
                  <v-text-field
                    filled shaped dense
                    label="Address" @input="showSave = true"
                    v-model="location.address"
                  ></v-text-field>
                </v-flex> -->
                <v-spacer></v-spacer>
                <v-slide-y-reverse-transition v-if="showSave" appear>
                  <!-- <v-flex class="pb-4"> -->
                    <v-dialog v-model="dialog" max-width="500">
                      <template v-slot:activator="{ on }">
                        <v-btn color="primary" width="85" @click="currentLocation = location" outlined v-on="on" class="font-weight-medium mr-6" rounded>Save</v-btn>
                      </template>
                      
                      <v-card>
                        <v-card-title>
                          Save changes to {{ location.name }}
                          <v-spacer />

                          <v-icon aria-label="Close" @click="dialog = false">mdi-close</v-icon>
                        </v-card-title>

                        <v-card-text class="body-1 text-center">
                          <v-form>
                            <!-- <v-text-field
                              outlined dense v-model="accessCode"
                              label="Verify Access Code" type="password"
                            ></v-text-field> -->
                          </v-form>
                          <v-btn
                            class="mt-3"
                            color="info"
                            depressed
                            default :loading="loading"
                            rounded
                            @click="updateLocation"
                          >Save</v-btn>
                          <p class="red--text mt-5" v-if="feedback">{{ feedback }}</p>
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                  <!-- </v-flex> -->
                </v-slide-y-reverse-transition>
                
                <!-- <v-flex class="pb-4"> -->
                <DeleteLocation :location="location" />
                <!-- </v-flex> -->
                
                <!-- <v-btn color="billit" class="font-weight-bold mt-2" width="40" outlined>Edit <v-icon class="ml-1">mdi-map-marker-radius-outline</v-icon></v-btn>
                <v-btn color="billit" class="font-weight-bold mt-2 ml-3" width="175" outlined>Manage Insurances <v-icon class="ml-2">mdi-card-account-details-outline</v-icon></v-btn> -->
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
  <!-- <base-material-snackbar
    v-model="snackbar"
    :type="color"
    v-bind="{
      [parsedDirection[0]]: true,
      [parsedDirection[1]]: true
    }"
  >
    Welcome to <span class="font-weight-bold">&nbsp;MATERIAL DASHBOARD&nbsp;</span> — a beautiful admin panel for every web developer.
  </base-material-snackbar>-->
</template>

<script>
import moment from 'moment'
import { db, functions } from '@/firebase'
import AddLocation from '@/components/misc/AddLocation'
import DeleteLocation from '@/components/misc/DeleteLocation'

export default {
  data: () => ({
    showSave: false,
    dialog: false,
    // accessCode: '',
    feedback: '',
    loading: false,
    editLocations: null,
  }),
  components: {
    AddLocation, DeleteLocation
  },
  created() {
    this.editLocations = this.$store.state.locations
  },
  computed: {},
  methods: {
    getTime(timestamp) {
      return moment(timestamp).format('llll')
    },
    updateLocation() {
      this.feedback = ''
      this.loading = true
      // const { accessCode } = this.$data
      let f = functions.httpsCallable('updateLocation')
      f({ location: this.currentLocation, locationId: this.currentLocation.id })
      .then(result => {
        setTimeout(() => {
          // this.accessCode = ''
          this.currentLocation = null
          this.editLocations = this.$store.state.locations
          this.showSave = false
          this.loading = false
          this.dialog = false
        }, 1000)
      })
      .catch(error => {
        this.loading = false
        this.feedback = error.message
      })
    }
  }
}
</script>
